<template>
  <div>
    <v-card-text class="px-10">
      <v-select
        prepend-icon="mdi-cellphone-android"
        :items="osList"
        item-text="name"
        item-value="value"
        v-model="os"
        label="操作系统"
        @change="reset"
      />
      <v-switch
        v-model="specific"
        v-if="(os === 'ANDROID' || os === 'IPA')"
        label="定制"
        @change="switchSpecific"
      ></v-switch>

      <v-switch
          v-model="commonSubscribe"
          v-if="((os === 'ANDROID' || os === 'IPA') && specific!==true )"
          label="通用发布(选择该选项则所有通用版本客户端都会使用当前版本作为最新版)"
          @change="switchSpecific"
      ></v-switch>

      <v-combobox
        v-if=specific
        v-model="selectSpecificItem"
        :items="infoNameList"
        label="请选择要定制的学校名称"
      ></v-combobox>
      <v-file-input
        v-if="os === 'ANDROID'"
        prepend-icon="mdi-package-variant-closed"
        accept=".apk"
        label="应用安装包"
        :rules="fileRules"
        v-model="fileObj"
        id="file"
        show-size
        counter
      />

      <v-card outlined class="my-5" v-if="!!fileObj && os === 'ANDROID'">
        <v-skeleton-loader type="list-item-avatar-three-line" v-if="!apkInfo || !digest"/>

        <v-list-item three-line v-else>
          <v-list-item-avatar tile size="96">
            <v-img :src="apkInfo.icon"/>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="text-h5 mb-1">
              {{ apkInfo.application.label.join(' / ') }}
              <span class="text-subtitle-1 pl-3">({{ apkInfo.package }})</span>
            </v-list-item-title>
            <v-list-item-subtitle class="digest">SHA-512: {{ digest }}</v-list-item-subtitle>
            <v-list-item-subtitle>
              versionName: {{ apkInfo.versionName }}<br>
              versionCode: {{ apkInfo.versionCode }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-file-input
        v-if="os === 'IPA'"
        prepend-icon="mdi-package-variant-closed"
        accept=".ipa"
        label="IPA 文件"
        :rules="fileRules"
        v-model="ipaObj"
        id="ipa-file"
        show-size
        counter
      />

      <v-card outlined class="my-5" v-if="!!ipaObj && os === 'IPA'">
        <v-skeleton-loader type="list-item-avatar" v-if="!ipaDigest"/>
        <v-list-item v-else>
          <v-list-item-avatar tile>
            <v-img src="../assets/e-campus.png"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="digest">SHA-512: {{ ipaDigest }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>

      <v-text-field
        v-if="os === 'IPA'"
        prepend-icon="mdi-identifier"
        label="Bundle ID"
        v-model="bundleId"
      />

      <v-text-field
        v-if="os !== 'ANDROID'"
        prepend-icon="mdi-history"
        label="版本号"
        v-model="versionName"
      />

      <v-text-field
        prepend-icon="mdi-rename-box"
        label="应用名称"
        v-model="appName"
      />

      <v-text-field
        v-if="os !== 'ANDROID' && os !== 'IPA'"
        :prepend-icon="os === 'IOS' ? 'mdi-apple' : 'mdi-download'"
        :label="os === 'IOS' ? 'App Store 地址' : '下载地址'"
        v-model="filePath"
      />

      <v-text-field
        prepend-icon="mdi-fencing"
        label="最小可用版本"
        v-model="minVersion"
      />

      <v-textarea
        prepend-icon="mdi-card-bulleted-outline"
        label="版本详情"
        rows="3"
        v-model="detail"
      />
    </v-card-text>

    <v-card-actions class="px-10">
      <v-spacer/>
      <v-btn outlined small color="red" @click.stop="close">关闭</v-btn>
      <v-btn
        small
        outlined
        color="blue darken-1"
        :loading="fileLoading"
        :disabled="fileLoading"
        @click="save"
      >
        保存
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import sha512 from 'js-sha512'
import AppInfoParser from 'app-info-parser'
import { buildAxios, uploadFile } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'

export default {
  name: 'UploadApp',
  data () {
    return {
      osList: [
        {
          name: 'Android',
          value: 'ANDROID'
        },
        {
          name: 'iOS (App Store)',
          value: 'IOS'
        },
        {
          name: 'iOS (IPA)',
          value: 'IPA'
        },
        {
          name: '其它',
          value: 'OTHER'
        }
      ],
      fileRules: [
        value => !value || value.size < 100 * 3000000 || '文件不能大于300MB！'
      ],
      fileObj: undefined,
      fileLoading: false,
      apkInfo: undefined,
      digest: undefined,
      os: 'ANDROID',
      ipaObj: undefined,
      ipaDigest: undefined,
      bundleId: '',
      commonSubscribe: false,
      appName: undefined,
      versionName: '',
      filePath: '',
      minVersion: '',
      detail: '',
      // 是否是指定版本
      specific: false,
      // 学校信息列表
      infoList: [],
      infoNameList: [],
      infoMap: [],
      selectSpecificItem: [],
      specificIcon: undefined,
      specificIconUrl: ''
    }
  },
  watch: {
    fileObj (newValue) {
      this.apkInfo = undefined
      this.digest = undefined
      if (newValue) {
        this.parseApk(newValue)
      }
    },
    ipaObj (newValue) {
      this.ipaDigest = undefined
      if (newValue) {
        this.digestFile(newValue, d => {
          this.ipaDigest = d
        })
      }
    },
    specificIcon (newValue) {
      // 控制图标预览显示
      if (this.specificIcon === null || this.specificIcon === undefined) {
        this.specificIconUrl = ''
      } else {
        this.specificIconUrl = URL.createObjectURL(this.specificIcon)
      }
    }
  },
  methods: {
    parseApk (apk) {
      const parser = new AppInfoParser(apk)
      parser.parse().then(result => {
        this.apkInfo = result
      }).catch(err => {
        console.log('err ----> ', err)
        this.fileObj = undefined
        this.$emit('alert', {
          msg: '安装包解析失败',
          type: 'error'
        })
      })

      const reader = new FileReader()
      reader.readAsArrayBuffer(apk)
      reader.onload = () => {
        const buffer = reader.result
        this.digest = sha512.hex(buffer)
      }
    },
    digestFile (file, callback) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onload = () => {
        const buffer = reader.result
        const digest = sha512.hex(buffer)
        callback(digest)
      }
    },
    reset () {
      this.fileObj = undefined
      this.fileLoading = false
      this.apkInfo = undefined
      this.digest = undefined
      this.versionName = ''
      this.filePath = ''
      this.minVersion = ''
      this.detail = ''
      this.ipaObj = undefined
      this.ipaDigest = undefined
      this.appName = undefined
      this.bundleId = ''
      this.selectSpecificItem = []
      this.specific = false
      this.commonSubscribe = false
    },
    close () {
      this.$emit('close')
    },
    save () {
      if (this.os === 'ANDROID' || this.os === 'IPA') {
        this.upload()
      } else {
        this.submit()
      }
    },
    upload () {
      this.fileLoading = true

      let file
      const commonSubscribe = this.commonSubscribe
      if (this.appName === null || this.appName === undefined) {
        this.appName = '慧新e校'
      }
      const payload = {
        os: this.os,
        detail: this.detail,
        minVersion: this.minVersion,
        specific: this.specific,
        appName: this.appName
      }
      if (this.os === 'ANDROID') {
        file = this.fileObj
        payload.versionCode = this.apkInfo.versionCode
        payload.versionName = this.apkInfo.versionName
        payload.sha512 = this.digest
      } else if (this.os === 'IPA') {
        file = this.ipaObj
        payload.versionName = this.versionName
        payload.sha512 = this.ipaDigest
        payload.filePath = this.bundleId
      }
      let specificUrlInfoId = null
      if (this.specific) {
        const specificUrlInfo = this.infoMap.get(this.selectSpecificItem)
        specificUrlInfoId = specificUrlInfo.id
      }
      uploadFile('app/upload', file, payload, commonSubscribe, specificUrlInfoId)
        .then(res => {
          this.fileLoading = false
          const returnItem = res.data.data
          if (this.specific) {
            this.saveSpecificLink(returnItem, this.selectSpecificItem)
          }
          this.reset()
          this.close()
          this.$emit('add', res.data.data)
        })
        .catch(reason => {
          this.fileLoading = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    submit () {
      this.fileLoading = true

      const request = buildAxios()
      request.post('app/add', {
        os: this.os,
        versionName: this.versionName,
        filePath: this.filePath,
        minVersion: this.minVersion,
        detail: this.detail,
        specific: this.specific
      })
        .then(res => {
          this.fileLoading = false
          this.reset()
          this.close()
          this.$emit('add', res.data.data)
        })
        .catch(reason => {
          this.fileLoading = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // 是否定制按钮切换
    switchSpecific (value) {
      console.log(value)
      console.log(this.selectSpecificItem)
      if (value) {
        this.urlInfoList()
        return
      }
      this.selectSpecificItem = []
      this.infoNameList = []
      this.specificIcon = undefined
      this.specificIconUrl = ''
    },
    // 校企信息列表
    urlInfoList () {
      const request = buildAxios()
      request.get('uni/infoList')
        .then(res => {
          this.infoList = res.data.data
          this.infoMap = new Map()
          this.infoNameList = []
          for (const info of this.infoList) {
            this.infoMap.set(info.uniName, info)
            this.infoNameList.push(info.uniName)
          }
          this.loading = false
        })
        .catch(reason => {
          this.loading = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    saveSpecificLink (item, selectItem) {
      const info = this.infoMap.get(selectItem)
      const appId = item.id
      const selected = []
      selected.push(info.id)
      const request = buildAxios()
      request.post('app/setLink', {
        appId: appId,
        customerIdSet: selected
      })
        .then(res => {
          console.log(res.data.data)
          this.$emit('close')
        })
        .catch(reason => {
          this.saving = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped>
.digest {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
